module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_8017.0b40e8f6.png";